import React from "react";
import CreateModelHeader from "./components/CreateModelHeader";
import CreateModelProgress from "./components/CreateModelProgress";
import { useState } from "react";
import Vector from "../../assets/Vector.svg"
import FormikControl from "../../components/signUpForm/ReusableFormik/FormikControl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import SuccessfulCreateModal from "./SuccessfulCreateModel"
import { ModelContext } from "./DataContext";
import { useContext } from "react";

function CreateModelStep5(){

const [IsSucessModalOpen, setSucessModallOpen] = useState(false)
const {modelData} = useContext(ModelContext);

  const  initialValues = {
    //Basic information
        modelName: modelData.modelName,
        modelCondition: modelData.modelCondition,
        param1: modelData.param1,
        param2: modelData.param2,
        selection1: modelData.selection1,
        selection2: modelData.selection2,

    //Bank statement analysis
        variable1_0: modelData.variable1_0,
        variable2_0: modelData.variable2_0,
        operator1_0: modelData.operator1_0,
        operator2_0: modelData.operator2_0,
        value1_0: modelData.value1_0,
        value2_0: modelData.value2_0,
        score1_0: modelData.score1_0,
        score2_0: modelData.score2_0,

    //Credit report analysis
        variable1: modelData.variable1,
        variable2: modelData.variable2,
        operator1: modelData.operator1,
        operator2: modelData.operator2,
        value1: modelData.value1,
        value2: modelData.value2,
        score1: modelData.score1,
        score2: modelData.score2,

    //wrap up
        passMark: modelData.passMark,
        score:modelData.score,
        tScore:modelData.totalScore,

}

const Parameters1 = [
    { value: '', key: 'Select' },
    { value: 'Age group', key: 'Age group' },
    { value: 'Employment type', key: 'Employment type' },
    { value: 'Location', key: 'Location' },
    { value: 'Loan amount range', key: 'Loan amount range' },
    { value: 'Salary range', key: 'Salary range' },
    { value: 'Gender', key: 'Gender' },
    { value: 'Loan Type', key: 'Loan Type' },
];

const Selection1 = [
    { value: '', key: 'Select' },
    { value: '25-35', key: '25-35' },
    { value: '36-45', key: '36-45' },
    { value: '46-55', key: '46-55' },
    { value: '46-55', key: '46-55' },
    { value: '66-75', key: '66-75' },
];

const Selection2 = [
    { value: '', key: 'Select' },
    { value: 'Unemployed', key: 'Unemployed' },
    { value: 'Employed', key: 'Employed' },
    { value: 'self employed', key: 'self employed' },
];

const Variable1_0 = [
    { value: '', key: 'Select' },
       { value: 'Monthly average income', key: 'Monthly average income' },
       { value: 'Monthly average expense', key: 'Monthly average expense' },
       { value: 'Total re-occuring expense', key: 'Total re-occuring expense' },
       { value: 'Average debit', key: 'Average debit' },
       { value: 'Average credit', key: 'Average credit' },
       { value: 'Average balance', key: 'Average balance' },
       { value: 'Most frequent balance', key: 'Most frequent balance' },
   ];

   const Operator1_0 = [
    { value: '', key: 'Select' },
       { value: 'Less than', key: 'Less than' },
       { value: 'Less than or equal to' , key: 'Less than or equal to' },
       { value: 'Greater than', key: 'Greater than' },
       { value: 'Greater than or equal to', key: 'Greater than or equal to' },
       { value: 'Equal to', key: 'Equal to' },
   ];

   const Operator1 = [
    { value: '', key: 'Select' },
       { value: 'Less than', key: 'Less than' },
       { value: 'Less than or equal to' , key: 'Less than or equal to' },
       { value: 'Greater than', key: 'Greater than' },
       { value: 'Greater than or equal to', key: 'Greater than or equal to' },
       { value: 'Equal to', key: 'Equal to' },
   ];

   const Variable1 = [
        { value: '', key: 'Select' },
        { value: 'Total credit account', key: 'Total credit account' },
        { value: 'Total lost', key: 'Total lost' },
        { value: 'Total doubtful', key: 'Total doubtful' },
        { value: 'Total watchlisted', key: 'Total watchlisted' },
        { value: 'Total substandard', key: 'Total substandard' },
        { value: 'Total dishonored cheque', key: 'Total dishonored cheque' },
        { value: 'Total outstanding loan', key: 'Total outstanding loan' },
        { value: 'Highest loan amount', key: 'Highest loan amount' },
        { value: 'Total overdue loan', key: 'Total overdue loan' },
   ];

   const options = [
    { value: '', key: 'Select' },
    { value: 'Apply model to all new applicants', key: 'Apply model to all new applicants' },
    { value: 'Apply model to selected applicants', key: 'Apply model to selected applicants' },
];

    const validationSchema = Yup.object({
        // variable1: Yup.string().required("Required"),
        // variable2: Yup.string().required("Required"),
        // operator1: Yup.string().required("Required"),
        // operator2: Yup.string().required("Required"),
        value1: Yup.string().required("Required"),
        value2: Yup.string().required("Required"),
        score1: Yup.string().required("Required"),
        score2: Yup.string().required("Required"),
    });

   


    const openSucess=()=>{
        setSucessModallOpen(true);
    }

    const closeSucess=()=>{
        setSucessModallOpen(false);
    }


    const onSubmit = (values) =>{
        openSucess();    
    }

    return(

        <div>
            <div>
                <CreateModelHeader/>
            </div>
            <div>
                <CreateModelProgress title={'Review Details'} indexActualPage={5}/>
            </div>

            <div>
                {/* className="mt-5 flex flex-col items-center justify-center bg-red-100" */}
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {(formik) => {
                        return (
                            <div className="mt-5">                           
                                <Form className="">
                                    {/* Basic information */}
                                <h1 className="text-success-email text-center">Basic information</h1>
                                <div className="flex flex-col items-center mt-5 pb-10 border-b-2 border-admin-border mx-4">
                                    <div className=""> 

                                        <FormikControl
                                            control="input"
                                            label="Model Name"
                                            type="text"                                       
                                            name="modelName"
                                        
                                        />   
                                        <span className="text-sm text-gray-600">The name you want to call this model</span>                               

                                        <FormikControl
                                            control="select"
                                            label="Condition for model application"
                                            name="modelCondition"
                                            options={options}
                                        />
                                
                                        <div className="mt-3">
                                            <div className="flex">
                                                <div className="mr-5 xl:w-[265px] sm:w-[190px]">
                                                    <FormikControl
                                                        control="select"
                                                        label="Parameters"
                                                        name="param1"
                                                        options={Parameters1}
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] sm:w-[190px]">
                                                    <FormikControl
                                                        control="select"
                                                        label="Selection"
                                                        // type="text"
                                                        name="selection1"
                                                        options={Selection1}
                                                    />
                                                </div>
                                                
                                            </div>

                                            <div className="flex">
                                                <div className="mr-5 xl:w-[265px] sm:w-[190px]">
                                                    <FormikControl
                                                        control="select"
                                                        label=""
                                                        // type="text"
                                                        name="param2"
                                                        options={Parameters1}
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] sm:w-[190px]">
                                                    <FormikControl
                                                        control="select"
                                                        label=""
                                                        // type="text"
                                                        name="selection2"
                                                        options={Selection2}
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>  
                                                                 
                                </div>



                                {/* Bank statement analysis */}
                                <div className="flex flex-col items-center mt-5 pb-10 border-b-2 border-admin-border mx-4">
                                    <h1 className="text-success-email text-center">Bank statement analysis</h1> 

                                    <div className="flex xl:flex-row md:flex-row sm:flex-col sm:items-center xl:justify-center sm:ml-3">                             
                                        <div className="flex">
                                            <div className="flex flex-col">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label="Variable"
                                                        // type="text"
                                                        name="variable1_0"
                                                        options={Variable1_0}
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label=""
                                                        // type="text"
                                                        name="variable2_0"
                                                        options={Variable1_0}
                                                    />
                                                </div>
                                                
                                            </div>

                                            <div className="flex flex-col">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label="Operator"
                                                        // type="text"
                                                        name="operator1_0"
                                                        options={Operator1_0}
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label=""
                                                        // type="text"
                                                        name="operator2_0"
                                                        options={Operator1_0}
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>

                                        <div className="flex mt-4">
                                            <div className="flex flex-col sm:-ml-4 xl:pl-3 md:pl-2">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4 flex justify-start -mt-1">
                                                    <img src={Vector} alt="Moeda" className="mr-1 mt-16" />  
                                                    <FormikControl
                                                        control="input"
                                                        label="Value"
                                                        type="text"
                                                        name="value1_0"
                                                
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] pl-4 mr-4 -mt-2">
                                                    <FormikControl
                                                        control="input"
                                                        label=""
                                                        type="text"
                                                        name="value2_0"                                                   
                                                    />
                                                </div>
                                                
                                            </div>

                                            <div className="flex flex-col">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] -mt-1">
                                                    <FormikControl
                                                        control="input"
                                                        label="Assigned Score"
                                                        type="text"
                                                        name="score1_0"                                               
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] -mt-2">
                                                    <FormikControl
                                                        control="input"
                                                        label=""
                                                        type="text"
                                                        name="score2_0"                                       
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>


                                {/* Credit risk analysis */}
                                <div className="flex flex-col items-center mt-5 pb-10 border-b-2 border-admin-border mx-4">
                                    <h1 className="text-success-email text-center">Credit risk analysis</h1> 
                                    <div className="flex xl:flex-row md:flex-row sm:flex-col sm:items-center xl:justify-center sm:ml-3">                             
                                        <div className="flex">
                                            <div className="flex flex-col">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label="Variable"
                                                        // type="text"
                                                        name="variable1"
                                                        options={Variable1}
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label=""
                                                        // type="text"
                                                        name="variable2"
                                                        options={Variable1}
                                                    />
                                                </div>
                                                
                                            </div>

                                            <div className="flex flex-col">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label="Operator"
                                                        // type="text"
                                                        name="operator1"
                                                        options={Operator1}
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4">
                                                    <FormikControl
                                                        control="select"
                                                        label=""
                                                        // type="text"
                                                        name="operator2"
                                                        options={Operator1}
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>

                                        <div className="flex mt-4">
                                            <div className="flex flex-col sm:-ml-4 xl:pl-3 md:pl-2">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4 flex justify-start -mt-1">
                                                    <img src={Vector} alt="Moeda" className="mr-1 mt-16" />  
                                                    <FormikControl
                                                        control="input"
                                                        label="Value"
                                                        type="text"
                                                        name="value1"
                                                
                                                    />
                                                </div>
                                                
                                                <div className="flex xl:w-[265px] md:w-[190px] sm:w-[200px] mr-4 -mt-3">
                                                    <img src={Vector} alt="Moeda" className="mr-1 mt-3" />  
                                                    <FormikControl
                                                        control="input"
                                                        label=""
                                                        type="text"
                                                        name="value2"
                                                    
                                                    />
                                                </div>
                                                
                                            </div>

                                            <div className="flex flex-col">
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] -mt-1">
                                                    <FormikControl
                                                        control="input"
                                                        label="Assigned Score"
                                                        type="text"
                                                        name="score1"
                                                
                                                    />
                                                </div>
                                                
                                                <div className="xl:w-[265px] md:w-[190px] sm:w-[200px] -mt-2">
                                                    <FormikControl
                                                        control="input"
                                                        label=""
                                                        type="text"
                                                        name="score2"                                       
                                                    />
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* Wrap up */}
                                <div className="flex flex-col items-center mt-5 pb-10 mx-4]">
                                    <h1 className="text-success-email text-center">Wrap Up</h1> 
                                        <div className="mb-2 w-[321px]">
                                            <FormikControl
                                                control="input"
                                                label="Total Score)"
                                                type="text"                                       
                                                name="tScore"                              
                                            /> 
                                            <span className="text-sm text-gray-600">This automatically adjusts with each variable score</span>  
                                        </div>
                                                                       
                                        <div className="w-[321px]">
                                            <FormikControl
                                                control="input"
                                                label="Pass Mark (required)"
                                                type="text"                                       
                                                name="passMark"                              
                                            />  
                                        </div>
                                        
                                        <div className="mt-2 w-[321px]">
                                            <FormikControl
                                                control="input"
                                                label="Least considerable score"
                                                type="text"
                                                name="score"
                                            />

                                        </div>                                 
                                </div>

                                <span className="flex justify-center mt-20 mb-20">
                                    <button     
                                        type="submit" 
                                        className='bg-indigo-500 hover:bg-indigo-600 text-slate-50 border rounded-md xl:px-5 md:px-2 lg:px-3 xl:py-2 md:w-28 xl:w-[150px] xl:h-[56px] sm:w-28 sm:h-12 sm;text-xs' 
                                        disabled={!formik.isValid}>
                                        Continue
                                    </button>
                                </span>
                            </Form>
                        </div>              
                            
                        );}}
                </Formik>  
            </div>

            {IsSucessModalOpen && (
                <SuccessfulCreateModal onClose={closeSucess} isOpen={IsSucessModalOpen}/>
            )} 
                   
        </div>
    )
}

export default CreateModelStep5;
           
            